import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import config from '../../../../config';
import { originalCourses } from '../../../../Data/originalCourses';
import { originalPackages } from '../../../../Data/originalPackages';
import { partnerCourses } from '../../../../Data/partnerCourses';
import { regionalCourses } from '../../../../Data/regionalCourses';
import { regionalLanguage } from '../../../../Data/regionalLanguage';
import { regionalCourseTypes } from '../../../../Data/regionalCourseTypes';
import { courseGroupNames } from '../../../../Data/courseGroupNames';
import { partnerCourseGroups } from '../../../../Data/partnerCourseGroups';
import { juniorsCourses } from '../../../../Data/juniorsCourses';
import { juniorsCourseGroups } from '../../../../Data/juniorsCourseGroups';
import { originalsPaths, partnerPlusPaths, animatedRegionalsPaths } from '../../../../Data/excludedPaths';
import {
  MobileCoursesContainer,
  MobileCourseGroupName,
  MobileCourse,
  MobileCourseIcon,
  RegionalCoursesLanguage,
  CourseTag,
  RegionalsLangIcon,
  RegionalsLangText,
  MobileNavHrLine,
} from './styles';

class CoursesMobileNav extends Component {
  handleCoursesNav = (courseID) => {
    window.location.href = `${config.domain}/${courseID}/?lb_content=${window.location.hostname + window.location.pathname}&lb_cta=courses-nav_bar`;
  };
  handleRegionalCoursesNav = (courseID) => {
    window.location.href = `${config.domain}/${courseID}/?lb_content=${window.location.hostname + window.location.pathname}&lb_cta=courses-nav_bar`;
  };
  handlePackagesNav = (packageID) => {
    window.location.href = `${config.domain}/${packageID}/?lb_content=${window.location.hostname + window.location.pathname}&lb_cta=packages-nav_bar`;
  };
  // handleRegionalLanguage = (id) => {
  //   window.location.href = `${config.domain}/${id}/?lb_content=${window.location.hostname + window.location.pathname}&lb_cta=regionals-nav_bar`;
  // };

  _renderCourseTag = (upComing, newCourse, freeCourse, earlyAccess, specialOffer, pricing, courseTheme, language) => {
    const { country, userPaidStatus, paidPath } = this.props;
    let noPaidPath = !userPaidStatus || paidPath === undefined;
    let originalsSpecialIndividuals = paidPath && originalsPaths.every((path) => !paidPath.includes(path));
    let partnerPlusSpecialIndividuals = paidPath && partnerPlusPaths.every((path) => !paidPath.includes(path));
    let regionalsAnimatedSpecialIndividuals =
      paidPath &&
      animatedRegionalsPaths.every((path) => !paidPath.includes(path)) &&
      !paidPath.includes(`prime-membership-${language}`) &&
      !paidPath.includes(`${language}-animation-membership`);
    let regionalsExpertSpecialIndividuals = paidPath && !paidPath.includes(`${language}-expert-membership`);

    return (
      <Fragment>
        {country === 'IN' &&
        (noPaidPath ||
          (courseTheme === 'originals' && originalsSpecialIndividuals) ||
          (courseTheme === 'partner-plus' && partnerPlusSpecialIndividuals) ||
          (courseTheme === 'regionals-animation' && regionalsAnimatedSpecialIndividuals) ||
          (courseTheme === 'regionals-expert' && regionalsExpertSpecialIndividuals)) &&
        pricing &&
        Object.keys(pricing).length !== 0 &&
        pricing[country] ? (
          <CourseTag specialPrice={true}>{pricing[country]}</CourseTag>
        ) : (
          <Fragment>
            {upComing && <CourseTag upComing>upcoming</CourseTag>}
            {newCourse && <CourseTag newCourse>new</CourseTag>}
            {freeCourse && <CourseTag freeCourse>free</CourseTag>}
            {earlyAccess && <CourseTag earlyAccess>early access</CourseTag>}
            {specialOffer && country === 'IN' && <CourseTag specialOffer>special offer</CourseTag>}
          </Fragment>
        )}
      </Fragment>
    );
  };

  render() {
    const { isFromInterview, isFromRegionalsMain, variant, isDashboard, darkTheme, language, coursesLanguage, courseCategory, country, packagesDropdown } = this.props;
    let cloudFront = config.cloudFront;

    if (packagesDropdown) {
      return (
        <MobileCoursesContainer id="mobilePackagesNav" isFromInterview={isFromInterview}>
          <RegionalCoursesLanguage
            isFromInterview={isFromInterview}
            darkTheme={darkTheme}
            // variant={variant}
          >
            Packages
          </RegionalCoursesLanguage>
          {originalPackages.map(({ id, title, img, whiteImg, pricing, upComing, newCourse, specialOffer }) => (
            <MobileCourse isDashboard={isDashboard} key={title} onClick={() => this.handlePackagesNav(id)} isFromInterview={isFromInterview}>
              <MobileCourseIcon src={isFromInterview || darkTheme ? cloudFront + whiteImg : cloudFront + img} />
              <div>
                <RegionalsLangText isDashboard={isDashboard} isFromInterview={isFromInterview}>
                  {title}
                </RegionalsLangText>

                {country === 'IN' && pricing && Object.keys(pricing).length !== 0 && pricing[country] ? (
                  <CourseTag specialPrice={true}>{pricing[country]}</CourseTag>
                ) : (
                  <Fragment>
                    {upComing && <CourseTag upComing>upcoming</CourseTag>}
                    {newCourse && <CourseTag newCourse>new</CourseTag>}
                    {specialOffer && country === 'IN' && <CourseTag specialOffer>special offer</CourseTag>}
                  </Fragment>
                )}
              </div>
            </MobileCourse>
          ))}
          {/*{country === 'IN' && (
            <Fragment>
              <MobileNavHrLine isFromInterview={isFromInterview} isDashboard={isDashboard} />
              {regionalLanguage.map(({ id, img, whiteImg, language, title }) => (
                <MobileCourse isDashboard={isDashboard} key={id} onClick={() => this.handleRegionalLanguage(id)} isFromInterview={isFromInterview}>
                  <RegionalsLangIcon src={isFromInterview || darkTheme ? cloudFront + whiteImg : cloudFront + img} />
                  <RegionalsLangText isDashboard={isDashboard} isFromInterview={isFromInterview}>
                    {title} Courses ({language})
                  </RegionalsLangText>
                </MobileCourse>
              ))}
            </Fragment>
          )}*/}
        </MobileCoursesContainer>
      );
    }
    // else if (isFromRegionalsMain) {
    //   return (
    //     <MobileCoursesContainer id="mobileRegionalsNav" isFromInterview={isFromInterview}>
    //       {regionalLanguage.map((group) => (
    //         <div key={group.id}>
    //           {regionalCourseTypes[group.id] &&
    //             Object.keys(regionalCourseTypes[group.id]) &&
    //             Object.keys(regionalCourseTypes[group.id]).map((groupName) => (
    //               <Fragment key={groupName}>
    //                 {regionalCourseTypes[group.id][groupName] ? (
    //                   <Fragment>
    //                     <MobileCourseGroupName isDashboard={isDashboard} darkTheme={darkTheme} isFromInterview={isFromInterview}>
    //                       {groupName === 'animation' ? 'Animated' : 'Expert'} <span className="weight-600">{group.language}</span> courses
    //                     </MobileCourseGroupName>

    //                     {regionalCourses[group.id][groupName].map(({ id, title, img, whiteImg, freeCourse, newCourse, earlyAccess, specialOffer, upComing }) => (
    //                       <MobileCourse
    //                         key={title}
    //                         isDashboard={isDashboard}
    //                         isFromInterview={isFromInterview}
    //                         nonClickable={upComing}
    //                         onClick={() => {
    //                           !upComing && this.handleRegionalCoursesNav(id);
    //                         }}
    //                       >
    //                         <MobileCourseIcon src={isFromInterview || darkTheme ? cloudFront + whiteImg : cloudFront + img} />
    //                         <div>
    //                           <RegionalsLangText isDashboard={isDashboard} isFromInterview={isFromInterview}>
    //                             {title}
    //                           </RegionalsLangText>

    //                           {upComing && <CourseTag upComing>upcoming</CourseTag>}
    //                           {newCourse && <CourseTag newCourse>new</CourseTag>}
    //                           {freeCourse && <CourseTag freeCourse>free</CourseTag>}
    //                           {earlyAccess && <CourseTag earlyAccess>early access</CourseTag>}
    //                           {specialOffer && country === 'IN' && <CourseTag specialOffer>special offer</CourseTag>}
    //                         </div>
    //                       </MobileCourse>
    //                     ))}
    //                   </Fragment>
    //                 ) : null}
    //               </Fragment>
    //             ))}
    //         </div>
    //       ))}
    //     </MobileCoursesContainer>
    //   );
    // }
    // else if (variant === 'regionals') {
    //   return (
    //     <MobileCoursesContainer id="mobileRegionalCoursesNav" isFromInterview={isFromInterview}>
    //       {regionalCourseTypes[language] &&
    //         Object.keys(regionalCourseTypes[language]) &&
    //         Object.keys(regionalCourseTypes[language]).map((groupName) => (
    //           <Fragment key={groupName}>
    //             {regionalCourseTypes[language][groupName] ? (
    //               <Fragment>
    //                 <MobileCourseGroupName isDashboard={isDashboard} darkTheme={darkTheme} isFromInterview={isFromInterview}>
    //                   {groupName === 'animation' ? 'Animated' : 'Expert'} <span className="weight-600">{coursesLanguage}</span> courses
    //                 </MobileCourseGroupName>

    //                 {regionalCourses[language][groupName].map(({ id, title, img, whiteImg, freeCourse, newCourse, earlyAccess, specialOffer, upComing }) => (
    //                   <MobileCourse
    //                     key={id}
    //                     isDashboard={isDashboard}
    //                     isFromInterview={isFromInterview}
    //                     nonClickable={upComing}
    //                     onClick={() => {
    //                       !upComing && this.handleRegionalCoursesNav(id);
    //                     }}
    //                   >
    //                     <MobileCourseIcon src={isFromInterview || darkTheme ? cloudFront + whiteImg : cloudFront + img} />
    //                     <div>
    //                       <RegionalsLangText isDashboard={isDashboard} isFromInterview={isFromInterview}>
    //                         {title}
    //                       </RegionalsLangText>

    //                       {upComing && <CourseTag upComing>upcoming</CourseTag>}
    //                       {newCourse && <CourseTag newCourse>new</CourseTag>}
    //                       {freeCourse && <CourseTag freeCourse>free</CourseTag>}
    //                       {earlyAccess && <CourseTag earlyAccess>early access</CourseTag>}
    //                       {specialOffer && country === 'IN' && <CourseTag specialOffer>special offer</CourseTag>}
    //                     </div>
    //                   </MobileCourse>
    //                 ))}
    //               </Fragment>
    //             ) : null}
    //           </Fragment>
    //         ))}
    //     </MobileCoursesContainer>
    //   );
    // }
    // else if (variant === 'partner-plus') {
    //   return (
    //     <MobileCoursesContainer id="mobilePartnerCoursesNav" isFromInterview={isFromInterview}>
    //       {partnerCourseGroups &&
    //         Object.keys(partnerCourseGroups) &&
    //         Object.keys(partnerCourseGroups).map((groupName) => (
    //           <Fragment key={groupName}>
    //             {partnerCourses[groupName] ? (
    //               <Fragment>
    //                 <MobileCourseGroupName isDashboard={isDashboard} darkTheme={darkTheme} isFromInterview={isFromInterview}>
    //                   {partnerCourseGroups[groupName]}
    //                 </MobileCourseGroupName>
    //                 {partnerCourses[groupName].map(({ id, title, img, whiteImg, freeCourse, newCourse, earlyAccess, specialOffer, upComing }) => (
    //                   <MobileCourse
    //                     key={id}
    //                     isDashboard={isDashboard}
    //                     isFromInterview={isFromInterview}
    //                     nonClickable={upComing}
    //                     onClick={() => {
    //                       !upComing && this.handleCoursesNav(id);
    //                     }}
    //                   >
    //                     <MobileCourseIcon src={isFromInterview || darkTheme ? cloudFront + whiteImg : cloudFront + img} />
    //                     <div>
    //                       <RegionalsLangText isDashboard={isDashboard} isFromInterview={isFromInterview}>
    //                         {title}
    //                       </RegionalsLangText>

    //                       {upComing && <CourseTag upComing>upcoming</CourseTag>}
    //                       {newCourse && <CourseTag newCourse>new</CourseTag>}
    //                       {freeCourse && <CourseTag freeCourse>free</CourseTag>}
    //                       {earlyAccess && <CourseTag earlyAccess>early access</CourseTag>}
    //                     </div>
    //                   </MobileCourse>
    //                 ))}
    //               </Fragment>
    //             ) : null}
    //           </Fragment>
    //         ))}
    //     </MobileCoursesContainer>
    //   );
    // }
    else if (variant === 'code-juniors') {
      return (
        <MobileCoursesContainer id="mobileJuniorCoursesNav" isFromInterview={isFromInterview}>
          {juniorsCourseGroups &&
            Object.keys(juniorsCourseGroups) &&
            Object.keys(juniorsCourseGroups).map((groupName) => (
              <Fragment key={groupName}>
                {juniorsCourses[groupName] ? (
                  <Fragment>
                    <MobileCourseGroupName isDashboard={isDashboard} darkTheme={darkTheme} isFromInterview={isFromInterview}>
                      {juniorsCourseGroups[groupName]}
                    </MobileCourseGroupName>
                    {juniorsCourses[groupName].map(({ id, title, img, whiteImg, freeCourse, newCourse, earlyAccess, specialOffer, upComing, pricing }) => (
                      <MobileCourse
                        key={id}
                        isDashboard={isDashboard}
                        isFromInterview={isFromInterview}
                        nonClickable={upComing}
                        onClick={() => {
                          !upComing && this.handleCoursesNav(id);
                        }}
                      >
                        <MobileCourseIcon src={isFromInterview || darkTheme ? cloudFront + whiteImg : cloudFront + img} />
                        <div>
                          <RegionalsLangText isDashboard={isDashboard} isFromInterview={isFromInterview}>
                            {title}
                          </RegionalsLangText>

                          {this._renderCourseTag(upComing, newCourse, freeCourse, earlyAccess, specialOffer, pricing, 'code-juniors')}

                          {/*{upComing && <CourseTag upComing>upcoming</CourseTag>}
                          {newCourse && <CourseTag newCourse>new</CourseTag>}
                          {freeCourse && <CourseTag freeCourse>free</CourseTag>}
                          {earlyAccess && <CourseTag earlyAccess>early access</CourseTag>}*/}
                        </div>
                      </MobileCourse>
                    ))}
                  </Fragment>
                ) : null}
              </Fragment>
            ))}

          <div className={`d-flex align-items-center fs-15 headingFont weight-500 pt-2 pl-2 ${darkTheme || isFromInterview ? 'text-light' : 'normalTxtColor'}`}>
            <img
              className="mr-2"
              style={{ width: '18px' }}
              src={darkTheme || isFromInterview ? `/Assets/sidemenu-courses-icon-white.svg` : `/Assets/sidemenu-courses-icon.svg`}
              alt=""
            />
            Original courses
          </div>

          {Object.keys(courseGroupNames).map((groupName) => (
            <div key={groupName}>
              {originalCourses[groupName] ? (
                <Fragment>
                  <MobileCourseGroupName isDashboard={isDashboard} darkTheme={darkTheme} isFromInterview={isFromInterview}>
                    {courseGroupNames[groupName]}
                  </MobileCourseGroupName>
                  {originalCourses[groupName].map(({ id, title, img, whiteImg, freeCourse, newCourse, earlyAccess, specialOffer, upComing, pricing }) => (
                    <MobileCourse
                      key={id}
                      isDashboard={isDashboard}
                      isFromInterview={isFromInterview}
                      nonClickable={upComing}
                      onClick={() => {
                        !upComing && this.handleCoursesNav(id);
                      }}
                    >
                      <MobileCourseIcon src={isFromInterview || darkTheme ? cloudFront + whiteImg : cloudFront + img} />
                      <div>
                        <RegionalsLangText isDashboard={isDashboard} isFromInterview={isFromInterview}>
                          {title}
                        </RegionalsLangText>

                        {this._renderCourseTag(upComing, newCourse, freeCourse, earlyAccess, specialOffer, pricing, 'originals')}

                        {/*{country === 'IN' && pricing && Object.keys(pricing).length !== 0 && pricing[country] ? (
                          <CourseTag specialPrice={true}>{pricing[country]}</CourseTag>
                        ) : (
                          <Fragment>
                            {upComing && <CourseTag upComing>upcoming</CourseTag>}
                            {newCourse && <CourseTag newCourse>new</CourseTag>}
                            {freeCourse && <CourseTag freeCourse>free</CourseTag>}
                            {earlyAccess && <CourseTag earlyAccess>early access</CourseTag>}
                            {specialOffer && country === 'IN' && <CourseTag specialOffer>special offer</CourseTag>}
                          </Fragment>
                        )}*/}
                      </div>
                    </MobileCourse>
                  ))}
                </Fragment>
              ) : null}
            </div>
          ))}

          {Object.keys(partnerCourseGroups).map((groupName) => (
            <Fragment key={groupName}>
              {partnerCourses[groupName] ? (
                <Fragment>
                  <MobileCourseGroupName isDashboard={isDashboard} darkTheme={darkTheme} isFromInterview={isFromInterview}>
                    {partnerCourseGroups[groupName]}
                  </MobileCourseGroupName>
                  {partnerCourses[groupName].map(({ id, title, img, whiteImg, freeCourse, newCourse, earlyAccess, specialOffer, upComing, pricing }) => (
                    <MobileCourse
                      key={id}
                      isDashboard={isDashboard}
                      isFromInterview={isFromInterview}
                      nonClickable={upComing}
                      onClick={() => {
                        !upComing && this.handleCoursesNav(id);
                      }}
                    >
                      <MobileCourseIcon src={isFromInterview || darkTheme ? cloudFront + whiteImg : cloudFront + img} />
                      <div>
                        <RegionalsLangText isDashboard={isDashboard} isFromInterview={isFromInterview}>
                          {title}
                        </RegionalsLangText>

                        {this._renderCourseTag(upComing, newCourse, freeCourse, earlyAccess, specialOffer, pricing, 'partner-plus')}

                        {/*{country === 'IN' && pricing && Object.keys(pricing).length !== 0 && pricing[country] ? (
                          <CourseTag specialPrice={true}>{pricing[country]}</CourseTag>
                        ) : (
                          <Fragment>
                            {upComing && <CourseTag upComing>upcoming</CourseTag>}
                            {newCourse && <CourseTag newCourse>new</CourseTag>}
                            {freeCourse && <CourseTag freeCourse>free</CourseTag>}
                            {earlyAccess && <CourseTag earlyAccess>early access</CourseTag>}
                            {specialOffer && country === 'IN' && <CourseTag specialOffer>special offer</CourseTag>}
                          </Fragment>
                        )}*/}
                      </div>
                    </MobileCourse>
                  ))}
                </Fragment>
              ) : null}
            </Fragment>
          ))}

          {country === 'IN' && (
            <Fragment>
              <div className={`d-flex align-items-center fs-15 headingFont weight-500 pt-2 pl-2 ${darkTheme || isFromInterview ? 'text-light' : 'normalTxtColor'}`}>
                <img
                  className="mr-2"
                  style={{ width: '18px' }}
                  src={
                    darkTheme || isFromInterview
                      ? `${cloudFront}/Assets/Dashboard/dboard-regionals-outline-light.svg`
                      : `${cloudFront}/Assets/Dashboard/dboard-regionals-outline.svg`
                  }
                  alt=""
                />
                Regional courses
              </div>

              {regionalLanguage.map((group) => (
                <div key={group.id}>
                  {regionalCourseTypes[group.id] &&
                    Object.keys(regionalCourseTypes[group.id]) &&
                    Object.keys(regionalCourseTypes[group.id]).map((groupName) => {
                      if (groupName === 'animation') {
                        return (
                          <Fragment key={`${group.id}-animation`}>
                            {regionalCourseTypes[group.id]['animation'] ? (
                              <Fragment>
                                <MobileCourseGroupName isDashboard={isDashboard} darkTheme={darkTheme} isFromInterview={isFromInterview}>
                                  Animated <span className="weight-600">{group.language}</span> courses
                                </MobileCourseGroupName>

                                {regionalCourses[group.id]['animation'].map(({ id, title, img, whiteImg, freeCourse, newCourse, earlyAccess, specialOffer, upComing, pricing }) => (
                                  <MobileCourse
                                    key={title}
                                    isDashboard={isDashboard}
                                    isFromInterview={isFromInterview}
                                    nonClickable={upComing}
                                    onClick={() => {
                                      !upComing && this.handleRegionalCoursesNav(id);
                                    }}
                                  >
                                    <MobileCourseIcon src={isFromInterview || darkTheme ? cloudFront + whiteImg : cloudFront + img} />
                                    <div>
                                      <RegionalsLangText isDashboard={isDashboard} isFromInterview={isFromInterview}>
                                        {title}
                                      </RegionalsLangText>

                                      {this._renderCourseTag(upComing, newCourse, freeCourse, earlyAccess, specialOffer, pricing, 'regionals-animation', group.id)}

                                      {/*{country === 'IN' && pricing && Object.keys(pricing).length !== 0 && pricing[country] ? (
                                        <CourseTag specialPrice={true}>{pricing[country]}</CourseTag>
                                      ) : (
                                        <Fragment>
                                          {upComing && <CourseTag upComing>upcoming</CourseTag>}
                                          {newCourse && <CourseTag newCourse>new</CourseTag>}
                                          {freeCourse && <CourseTag freeCourse>free</CourseTag>}
                                          {earlyAccess && <CourseTag earlyAccess>early access</CourseTag>}
                                          {specialOffer && country === 'IN' && <CourseTag specialOffer>special offer</CourseTag>}
                                        </Fragment>
                                      )}*/}
                                    </div>
                                  </MobileCourse>
                                ))}
                              </Fragment>
                            ) : null}
                          </Fragment>
                        );
                      } else return null;
                    })}
                </div>
              ))}
            </Fragment>
          )}
        </MobileCoursesContainer>
      );
    } else {
      return (
        <MobileCoursesContainer id="mobileOriginalCoursesNav" isFromInterview={isFromInterview}>
          {variant === 'regionals' && (
            <Fragment>
              {courseCategory === 'professional' && (
                <Fragment>
                  <div className="pb-2">
                    {regionalLanguage.map((group) => (
                      <div key={group.id}>
                        {regionalCourseTypes[group.id] &&
                          Object.keys(regionalCourseTypes[group.id]) &&
                          Object.keys(regionalCourseTypes[group.id]).map((groupName) => {
                            if (groupName === 'professional') {
                              return (
                                <Fragment key={`${group.id}-professional`}>
                                  {regionalCourseTypes[group.id]['professional'] ? (
                                    <Fragment>
                                      <MobileCourseGroupName isDashboard={isDashboard} darkTheme={darkTheme} isFromInterview={isFromInterview}>
                                        Expert <span className="weight-600">{group.language}</span> courses
                                      </MobileCourseGroupName>

                                      {regionalCourses[group.id]['professional'].map(
                                        ({ id, title, img, whiteImg, freeCourse, newCourse, earlyAccess, specialOffer, upComing, pricing }) => (
                                          <MobileCourse
                                            key={title}
                                            isDashboard={isDashboard}
                                            isFromInterview={isFromInterview}
                                            nonClickable={upComing}
                                            onClick={() => {
                                              !upComing && this.handleRegionalCoursesNav(id);
                                            }}
                                          >
                                            <MobileCourseIcon src={isFromInterview || darkTheme ? cloudFront + whiteImg : cloudFront + img} />
                                            <div>
                                              <RegionalsLangText isDashboard={isDashboard} isFromInterview={isFromInterview}>
                                                {title}
                                              </RegionalsLangText>

                                              {this._renderCourseTag(upComing, newCourse, freeCourse, earlyAccess, specialOffer, pricing, 'regionals-expert', group.id)}

                                              {/*{country === 'IN' && pricing && Object.keys(pricing).length !== 0 && pricing[country] ? (
                                                <CourseTag specialPrice={true}>{pricing[country]}</CourseTag>
                                              ) : (
                                                <Fragment>
                                                  {upComing && <CourseTag upComing>upcoming</CourseTag>}
                                                  {newCourse && <CourseTag newCourse>new</CourseTag>}
                                                  {freeCourse && <CourseTag freeCourse>free</CourseTag>}
                                                  {earlyAccess && <CourseTag earlyAccess>early access</CourseTag>}
                                                  {specialOffer && country === 'IN' && <CourseTag specialOffer>special offer</CourseTag>}
                                                </Fragment>
                                              )}*/}
                                            </div>
                                          </MobileCourse>
                                        )
                                      )}
                                    </Fragment>
                                  ) : null}
                                </Fragment>
                              );
                            } else return null;
                          })}
                      </div>
                    ))}
                  </div>

                  <div className={`d-flex align-items-center fs-15 headingFont weight-500 pl-2 ${darkTheme || isFromInterview ? 'text-light' : 'normalTxtColor'}`}>
                    <img
                      className="mr-2"
                      style={{ width: '18px' }}
                      src={
                        darkTheme || isFromInterview
                          ? `${cloudFront}/Assets/Dashboard/dboard-regionals-outline-light.svg`
                          : `${cloudFront}/Assets/Dashboard/dboard-regionals-outline.svg`
                      }
                      alt=""
                    />
                    Regional courses
                  </div>
                </Fragment>
              )}

              {regionalLanguage.map((group) => (
                <div key={group.id}>
                  {regionalCourseTypes[group.id] &&
                    Object.keys(regionalCourseTypes[group.id]) &&
                    Object.keys(regionalCourseTypes[group.id]).map((groupName) => {
                      if (groupName === 'animation') {
                        return (
                          <Fragment key={`${group.id}-animation`}>
                            {regionalCourseTypes[group.id]['animation'] ? (
                              <Fragment>
                                <MobileCourseGroupName isDashboard={isDashboard} darkTheme={darkTheme} isFromInterview={isFromInterview}>
                                  Animated <span className="weight-600">{group.language}</span> courses
                                </MobileCourseGroupName>

                                {regionalCourses[group.id]['animation'].map(({ id, title, img, whiteImg, freeCourse, newCourse, earlyAccess, specialOffer, upComing, pricing }) => (
                                  <MobileCourse
                                    key={title}
                                    isDashboard={isDashboard}
                                    isFromInterview={isFromInterview}
                                    nonClickable={upComing}
                                    onClick={() => {
                                      !upComing && this.handleRegionalCoursesNav(id);
                                    }}
                                  >
                                    <MobileCourseIcon src={isFromInterview || darkTheme ? cloudFront + whiteImg : cloudFront + img} />
                                    <div>
                                      <RegionalsLangText isDashboard={isDashboard} isFromInterview={isFromInterview}>
                                        {title}
                                      </RegionalsLangText>

                                      {this._renderCourseTag(upComing, newCourse, freeCourse, earlyAccess, specialOffer, pricing, 'regionals-animation', group.id)}

                                      {/*{country === 'IN' && pricing && Object.keys(pricing).length !== 0 && pricing[country] ? (
                                        <CourseTag specialPrice={true}>{pricing[country]}</CourseTag>
                                      ) : (
                                        <Fragment>
                                          {upComing && <CourseTag upComing>upcoming</CourseTag>}
                                          {newCourse && <CourseTag newCourse>new</CourseTag>}
                                          {freeCourse && <CourseTag freeCourse>free</CourseTag>}
                                          {earlyAccess && <CourseTag earlyAccess>early access</CourseTag>}
                                          {specialOffer && country === 'IN' && <CourseTag specialOffer>special offer</CourseTag>}
                                        </Fragment>
                                      )}*/}
                                    </div>
                                  </MobileCourse>
                                ))}
                              </Fragment>
                            ) : null}
                          </Fragment>
                        );
                      } else return null;
                    })}
                </div>
              ))}

              <div className={`d-flex align-items-center fs-15 headingFont weight-500 pt-2 pl-2 ${darkTheme || isFromInterview ? 'text-light' : 'normalTxtColor'}`}>
                <img
                  className="mr-2"
                  style={{ width: '18px' }}
                  src={darkTheme || isFromInterview ? `/Assets/sidemenu-courses-icon-white.svg` : `/Assets/sidemenu-courses-icon.svg`}
                  alt=""
                />
                Original courses
              </div>
            </Fragment>
          )}

          {Object.keys(courseGroupNames).map((groupName) => (
            <div key={groupName}>
              {originalCourses[groupName] ? (
                <Fragment>
                  <MobileCourseGroupName isDashboard={isDashboard} darkTheme={darkTheme} isFromInterview={isFromInterview}>
                    {courseGroupNames[groupName]}
                  </MobileCourseGroupName>
                  {originalCourses[groupName].map(({ id, title, img, whiteImg, freeCourse, newCourse, earlyAccess, specialOffer, upComing, pricing }) => (
                    <MobileCourse
                      key={id}
                      isDashboard={isDashboard}
                      isFromInterview={isFromInterview}
                      nonClickable={upComing}
                      onClick={() => {
                        !upComing && this.handleCoursesNav(id);
                      }}
                    >
                      <MobileCourseIcon src={isFromInterview || darkTheme ? cloudFront + whiteImg : cloudFront + img} />
                      <div>
                        <RegionalsLangText isDashboard={isDashboard} isFromInterview={isFromInterview}>
                          {title}
                        </RegionalsLangText>

                        {this._renderCourseTag(upComing, newCourse, freeCourse, earlyAccess, specialOffer, pricing, 'originals')}

                        {/*{country === 'IN' && pricing && Object.keys(pricing).length !== 0 && pricing[country] ? (
                          <CourseTag specialPrice={true}>{pricing[country]}</CourseTag>
                        ) : (
                          <Fragment>
                            {upComing && <CourseTag upComing>upcoming</CourseTag>}
                            {newCourse && <CourseTag newCourse>new</CourseTag>}
                            {freeCourse && <CourseTag freeCourse>free</CourseTag>}
                            {earlyAccess && <CourseTag earlyAccess>early access</CourseTag>}
                            {specialOffer && country === 'IN' && <CourseTag specialOffer>special offer</CourseTag>}
                          </Fragment>
                        )}*/}
                      </div>
                    </MobileCourse>
                  ))}
                </Fragment>
              ) : null}
            </div>
          ))}

          {Object.keys(partnerCourseGroups).map((groupName) => (
            <Fragment key={groupName}>
              {partnerCourses[groupName] ? (
                <Fragment>
                  <MobileCourseGroupName isDashboard={isDashboard} darkTheme={darkTheme} isFromInterview={isFromInterview}>
                    {partnerCourseGroups[groupName]}
                  </MobileCourseGroupName>
                  {partnerCourses[groupName].map(({ id, title, img, whiteImg, freeCourse, newCourse, earlyAccess, specialOffer, upComing, pricing }) => (
                    <MobileCourse
                      key={id}
                      isDashboard={isDashboard}
                      isFromInterview={isFromInterview}
                      nonClickable={upComing}
                      onClick={() => {
                        !upComing && this.handleCoursesNav(id);
                      }}
                    >
                      <MobileCourseIcon src={isFromInterview || darkTheme ? cloudFront + whiteImg : cloudFront + img} />
                      <div>
                        <RegionalsLangText isDashboard={isDashboard} isFromInterview={isFromInterview}>
                          {title}
                        </RegionalsLangText>

                        {this._renderCourseTag(upComing, newCourse, freeCourse, earlyAccess, specialOffer, pricing, 'partner-plus')}

                        {/*{country === 'IN' && pricing && Object.keys(pricing).length !== 0 && pricing[country] ? (
                          <CourseTag specialPrice={true}>{pricing[country]}</CourseTag>
                        ) : (
                          <Fragment>
                            {upComing && <CourseTag upComing>upcoming</CourseTag>}
                            {newCourse && <CourseTag newCourse>new</CourseTag>}
                            {freeCourse && <CourseTag freeCourse>free</CourseTag>}
                            {earlyAccess && <CourseTag earlyAccess>early access</CourseTag>}
                            {specialOffer && country === 'IN' && <CourseTag specialOffer>special offer</CourseTag>}
                          </Fragment>
                        )}*/}
                      </div>
                    </MobileCourse>
                  ))}
                </Fragment>
              ) : null}
            </Fragment>
          ))}

          {country === 'IN' && variant !== 'regionals' && (
            <Fragment>
              <div className={`d-flex align-items-center fs-15 headingFont weight-500 pt-2 pl-2 ${darkTheme || isFromInterview ? 'text-light' : 'normalTxtColor'}`}>
                <img
                  className="mr-2"
                  style={{ width: '18px' }}
                  src={
                    darkTheme || isFromInterview
                      ? `${cloudFront}/Assets/Dashboard/dboard-regionals-outline-light.svg`
                      : `${cloudFront}/Assets/Dashboard/dboard-regionals-outline.svg`
                  }
                  alt=""
                />
                Regional courses
              </div>

              {regionalLanguage.map((group) => (
                <div key={group.id}>
                  {regionalCourseTypes[group.id] &&
                    Object.keys(regionalCourseTypes[group.id]) &&
                    Object.keys(regionalCourseTypes[group.id]).map((groupName) => {
                      if (groupName === 'animation') {
                        return (
                          <Fragment key={`${group.id}-animation`}>
                            {regionalCourseTypes[group.id]['animation'] ? (
                              <Fragment>
                                <MobileCourseGroupName isDashboard={isDashboard} darkTheme={darkTheme} isFromInterview={isFromInterview}>
                                  Animated <span className="weight-600">{group.language}</span> courses
                                </MobileCourseGroupName>

                                {regionalCourses[group.id]['animation'].map(({ id, title, img, whiteImg, freeCourse, newCourse, earlyAccess, specialOffer, upComing, pricing }) => (
                                  <MobileCourse
                                    key={title}
                                    isDashboard={isDashboard}
                                    isFromInterview={isFromInterview}
                                    nonClickable={upComing}
                                    onClick={() => {
                                      !upComing && this.handleRegionalCoursesNav(id);
                                    }}
                                  >
                                    <MobileCourseIcon src={isFromInterview || darkTheme ? cloudFront + whiteImg : cloudFront + img} />
                                    <div>
                                      <RegionalsLangText isDashboard={isDashboard} isFromInterview={isFromInterview}>
                                        {title}
                                      </RegionalsLangText>

                                      {this._renderCourseTag(upComing, newCourse, freeCourse, earlyAccess, specialOffer, pricing, 'regionals-animation', group.id)}

                                      {/*{country === 'IN' && pricing && Object.keys(pricing).length !== 0 && pricing[country] ? (
                                        <CourseTag specialPrice={true}>{pricing[country]}</CourseTag>
                                      ) : (
                                        <Fragment>
                                          {upComing && <CourseTag upComing>upcoming</CourseTag>}
                                          {newCourse && <CourseTag newCourse>new</CourseTag>}
                                          {freeCourse && <CourseTag freeCourse>free</CourseTag>}
                                          {earlyAccess && <CourseTag earlyAccess>early access</CourseTag>}
                                          {specialOffer && country === 'IN' && <CourseTag specialOffer>special offer</CourseTag>}
                                        </Fragment>
                                      )}*/}
                                    </div>
                                  </MobileCourse>
                                ))}
                              </Fragment>
                            ) : null}
                          </Fragment>
                        );
                      } else return null;
                    })}
                </div>
              ))}
            </Fragment>
          )}
        </MobileCoursesContainer>
      );
    }
  }
}

const mapStateToProps = ({ Dashboard }) => ({
  userPaidStatus: Dashboard.trialAndInProgress && Dashboard.trialAndInProgress.paidStatus,
  paidPath: Dashboard.trialAndInProgress && Dashboard.trialAndInProgress.path,
});

export default connect(mapStateToProps, null)(CoursesMobileNav);
